import { isUserAdmin } from '@common/utils';
const metadata = {
  title: 'Min butik',
  routes: {
    ['/oversikt']: {
      label: 'Översikt'
    },
    '/kampanjer': {
      label: 'Kampanjer'
    },
    '/mitt-ombud': {
      label: 'Mitt ombud'
    },
    '/mitt-team': {
      label: 'Mitt team',
      useIsAllowed: isUserAdmin
    }
  }
};
export { metadata };